import api from './api';

/** Bill-to-specific calls that complement the generic /tablemaint engine:
 *  dropdown option sources, the deletable check, and the intelligence summary. */

export interface BilltoOption {
  value: string;
  label: string;
}

export interface BilltoFormOptions {
  salesreps: BilltoOption[];
  uom: BilltoOption[];
  perdiemdaystype: BilltoOption[];
  frequency: BilltoOption[];
  defaultfuelcalc: BilltoOption[];
  invoicingtype: BilltoOption[];
}

export interface BilltoContext {
  inUse: boolean;
  deletable: boolean;
}

export interface BilltoIntelligenceYear {
  year: number;
  volume: number;
  revenue: number;
  margin: number | null;
}

/** The only bill-to document type (V1 DS2-3215). */
export const BILLTO_DOC_TYPE = 'INVOICING A/P QUESTIONNAIRE';

const billtosService = {
  async formOptions(signal?: AbortSignal): Promise<BilltoFormOptions> {
    const res = await api.get('/billtos/form-options', { signal });
    return res.data as BilltoFormOptions;
  },

  async context(recno: number, signal?: AbortSignal): Promise<BilltoContext> {
    const res = await api.get(`/billtos/${recno}/context`, { signal });
    return res.data as BilltoContext;
  },

  async intelligence(recno: number, signal?: AbortSignal): Promise<{ years: BilltoIntelligenceYear[] }> {
    const res = await api.get(`/billtos/${recno}/intelligence`, { signal });
    return res.data as { years: BilltoIntelligenceYear[] };
  },
};

export default billtosService;
